import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import { globalHistory } from '@reach/router';
import { scroller } from 'react-scroll';
import ToolboxLayout from 'layouts/toolboxLayout';
import toolboxLogos from 'components/Toolbox/data/toolboxLogos';
import toolboxSections from 'components/Toolbox/data/toolboxSections';
import toolboxCardSections from 'components/Toolbox/data/toolboxCardSections';
import ImageCardSliderSection from 'components/ImageCardSections/ImageCardCarouselSection/ImageCardSliderSection';
import ImageCardSliderToolbox from 'components/ImageCardSections/ImageCardCarouselSection/ImageCardSliderToolbox';
import DownloadsResourcesSection from 'components/Downloads/ResourcesSection';
import BannerAd from 'components/Toolbox/BannerAd';
import Hero from 'components/Toolbox/Hero';

const Toolbox = props => {
  const backgroundImage = props.data.contentfulWebsiteImage;

  const {
    featuredContent,
    mostPopularPosts,
    bannerAds,
    seo: seoContent,
  } = props.data.contentfulWebsiteContentHub;

  useEffect(() => {
    const { hash } = globalHistory.location;
    const hashString = hash.substring(1);

    if (hash) {
      setTimeout(() => {
        scroller.scrollTo(hashString, {
          duration: 1500,
          delay: 100,
          smooth: true,
          offset: -100,
        });
      });
    }
  }, []);

  const { articlesBlackLogo, podcastBlackLogo, webinarBlackLogo } = toolboxLogos();
  const sections = toolboxSections();
  const cardSections = toolboxCardSections(props);

  return (
    <ToolboxLayout backgroundColor="#222" contentfulSeo={seoContent}>
      <Hero featuredContent={featuredContent} backgroundImage={backgroundImage} />
      <ImageCardSliderToolbox
        title="Most Popular"
        titleIcon="icon-popular"
        sectionsData={mostPopularPosts}
        sectionsIcon={{
          articles_logo: articlesBlackLogo,
          podcast_logo: podcastBlackLogo,
          webinar_logo: webinarBlackLogo,
        }}
        hubType="Toolbox"
      />
      {cardSections.map((section, index) => {
        return (
          <>
            {index % 3 === 0 && <BannerAd bannerContent={bannerAds[index / 3]} />}
            {section.data.length > 0 && (
              <ImageCardSliderSection
                key={index}
                title={section.category}
                titleIcon={sections[section.category]?.src_black}
                sectionsData={
                  section.ad && section.data.length >= 10 ? section.data.slice(0, 9) : section.data
                }
                sectionsAd={section.ad}
                hubType="Toolbox"
                viewAll={sections[section.category]?.viewAll}
              />
            )}
          </>
        );
      })}
      {false && (
        <DownloadsResourcesSection
          id="download"
          templatePosts={props.data.allTemplates?.nodes}
          salaryPosts={props.data.allSalary?.nodes}
          licensePosts={props.data.allLicenses?.nodes}
        />
      )}
    </ToolboxLayout>
  );
};

export default Toolbox;

export const ToolBoxPage = graphql`
  query ToolboxPageQuery {
    contentfulWebsiteContentHub(internalName: { eq: "Toolbox" }) {
      seo {
        ...Seo
      }
      websiteHeader {
        ...WebsiteHeader
      }
      announcementBanner {
        ...ConversionPanel
      }
      featuredContent {
        ...Blog
        ...Webinar
        ...Podcast
        ...GatedContent
      }
      mostPopularPosts {
        ...Blog
        ...Webinar
        ...Podcast
        ...GatedContent
      }
      webinarAd {
        ...Ads
      }
      articleAd {
        ...Ads
      }
      podcastAd {
        ...Ads
      }
      guidesAd {
        ...Ads
      }
      toolsAd {
        ...Ads
      }
      bannerAds {
        ...Ads
        ...ConversionPanel
      }
    }
    allArticle: allContentfulBlog(
      sort: { fields: [publishDate], order: DESC }
      filter: { tags: { nin: "Covid19" }, slug: { regex: "/^(?!success-story.*$).*/g" } }
      limit: 10
    ) {
      nodes {
        ...Blog
      }
    }
    allSuccessStory: allContentfulBlog(
      sort: { fields: [publishDate], order: DESC }
      filter: { slug: { regex: "/^success-story/g" } }
      limit: 10
    ) {
      nodes {
        ...Blog
      }
    }
    allContentfulWebinar(
      filter: { taxonomy: { topics: { nin: "Covid" } }, onDemandPage: { eq: true } }
      limit: 10
      sort: { order: DESC, fields: createdAt }
    ) {
      nodes {
        ...Webinar
      }
    }
    allContentfulPodcast(
      filter: { series: { eq: "Tools of the Trade" } }
      limit: 10
      sort: { order: DESC, fields: podcastDate }
    ) {
      nodes {
        ...Podcast
      }
    }
    allContentfulGatedContentPage(
      filter: { internalPageName: { ne: "Gated Content Test" } }
      sort: { order: DESC, fields: id }
      limit: 10
    ) {
      nodes {
        ...GatedContent
      }
    }
    allTemplates: allContentfulDownloadableContent(
      filter: { downloadableContentType: { eq: "Templates" } }
    ) {
      nodes {
        ...DownloadableContent
      }
    }
    allSalary: allContentfulDownloadableContent(
      filter: { downloadableContentType: { eq: "Salary Pieces" } }
    ) {
      nodes {
        ...DownloadableContent
      }
    }
    allLicenses: allContentfulDownloadableContent(
      filter: { downloadableContentType: { eq: "Licensing" } }
    ) {
      nodes {
        ...DownloadableContent
      }
    }
  }
`;
